<!-- START OF FILE EditSucai.vue -->
<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-09-01 14:05:48
 * @LastEditors: geory
 * @LastEditTime: 2026-07-24 10:57:18
-->
<template>
  <div class="editSucaiCover">
    <div class="editSucaiMain">
      <div class="editSucaiMainT">
        <div class="editSucaiMainTL">发布素材</div>
        <img
          class="editSucaiMainTR"
          src="https://imagessl.lingtuo.cn/A-1ed71af7_20260128110047.png"
          @click="close"
        />
      </div>
      <div class="editSucaiMainB">
        <div class="formItem">
          <div class="formItemL">内容</div>
          <div
            class="formItemR"
            :style="{ width: '720px' }"
          >
            <textarea v-model="contentTxt"></textarea>
          </div>
        </div>
        <div class="formItem">
          <div class="formItemL">素材类型</div>
          <div class="formItemR">
            <el-radio
              v-model="sucaiType"
              label="1"
              text-color="#FB5D5C"
              size="medium"
              >图片</el-radio
            >
            <el-radio
              v-model="sucaiType"
              label="2"
              text-color="#FB5D5C"
              size="medium"
              >视频</el-radio
            >
            <span v-if="isVip">
              <el-radio
                v-model="sucaiType"
                label="3"
                text-color="#FB5D5C"
                size="medium"
                >链接</el-radio
              >
            </span>
          </div>
        </div>
        <div
          v-if="sucaiType == '3'"
          class="formItem"
        >
          <div class="formItemL">链接标题</div>
          <div class="formItemR">
            <el-input
              v-model="linkTitle"
              placeholder="请输入链接标题"
            ></el-input>
          </div>
        </div>
        <div
          v-if="sucaiType == '3'"
          class="formItem"
        >
          <div class="formItemL">链接URL</div>
          <div class="formItemR">
            <el-input
              v-model="linkUrl"
              placeholder="请输入链接URL"
            ></el-input>
          </div>
        </div>
        <div
          v-if="sucaiType == '3'"
          class="formItem"
        >
          <div class="formItemL">封面图</div>
          <div class="formItemR">
            <div>
              <div
                v-if="!mediaArr.length"
                class="videoItem uploadArea"
                @click="triggerFileInput"
              >
                <img
                  src="https://imagessl.lingtuo.cn/A-1ed71af7_20260129142041.png"
                />
              </div>
              <div
                v-else
                class="videoItem"
              >
                <div class="videoPreview">
                  <img
                    :src="
                      mediaArr[0].picUrl
                        ? 'https://' + mediaArr[0].picUrl
                        : getObjectURL(mediaArr[0].file)
                    "
                    class="videoPreviewVideo"
                  />
                  <button
                    class="videoRemoveBtn"
                    @click="clearSelectedFiles"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="sucaiType === '1' || sucaiType === '2'"
          class="formItem"
        >
          <div class="formItemL">上传素材</div>
          <div class="formItemR">
            <div
              v-if="sucaiType == '1'"
              class="uploadCover"
              @dragover.prevent="handleDragOver"
              @drop.prevent="handleFileDrop"
              @dragenter.prevent="handleDragEnter"
              @dragleave.prevent="handleDragLeave"
              :class="{ 'drag-over': isDragging }"
            >
              <!-- 始终显示上传区域 -->
              <div class="emptyUploadArea">
                <input
                  ref="fileInput"
                  type="file"
                  class="emptyFileInput"
                  @change="handleFileSelect"
                  :accept="getFileAccept"
                  multiple
                />
                <div class="uploadPrompt">点击上传，或拖拽文件到此处</div>
              </div>
            </div>
            <div v-else-if="sucaiType == '2'">
              <div
                v-if="!mediaArr.length && !sucaiData.videoKey"
                class="videoItem uploadArea"
                @click="triggerFileInput"
              >
                <img
                  src="https://imagessl.lingtuo.cn/A-1ed71af7_20260129103439.png"
                />
              </div>
              <div
                v-else
                class="videoItem"
              >
                <div class="videoPreview">
                  <video
                    :src="
                      mediaArr.length
                        ? getObjectURL(mediaArr[0].file)
                        : sucaiData.mediaDomain + sucaiData.videoKey
                    "
                    class="videoPreviewVideo"
                    ref="sucaiVideo"
                    muted
                    preload="metadata"
                  ></video>
                  <img
                    class="videoPlayIcon"
                    src="https://imagessl.lingtuo.cn/A-1ed71af7_20260129111103.png"
                    @click="previewVideo"
                  />
                  <button
                    class="videoRemoveBtn"
                    @click="clearSelectedFiles"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 单独的文件展示区域 -->
        <div
          v-if="mediaArr.length > 0 && sucaiType === '1'"
          class="formItem"
        >
          <div class="formItemL"></div>
          <div
            class="formItemR"
            :style="{
              'background-color': '#FAFAFA',
              'max-height': '400px',
              overflow: 'scroll',
            }"
          >
            <!-- 增加拖拽排序功能 -->
            <div class="filesGrid">
              <div
                v-for="(mediaItem, index) in mediaArr"
                :key="mediaItem.uid || index"
                class="fileGridItem"
                draggable="true"
                @dragstart="handleItemDragStart(index, $event)"
                @dragover.prevent
                @dragenter="handleItemDragEnter(index, $event)"
                @dragend="handleItemDragEnd"
                @drop="handleItemDrop(index, $event)"
                :class="{ 'is-dragging': draggingIndex === index }"
                @click="imgPreview(index)"
              >
                <div class="filePreview">
                  <div
                    v-if="mediaItem.file && isImageFile(mediaItem.file)"
                    class="previewContainer"
                  >
                    <img
                      :src="getObjectURL(mediaItem.file)"
                      class="filePreviewImg"
                    />
                  </div>
                  <div
                    v-else-if="mediaItem.picUrl"
                    class="previewContainer"
                  >
                    <img
                      :src="sucaiData.domain + mediaItem.picUrl"
                      class="filePreviewImg"
                    />
                  </div>
                  <button
                    class="fileRemoveBtn"
                    @click="removeFile(index)"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="formItem">
          <div class="formItemL">选择分类</div>
          <div
            class="formItemR"
            :style="{ width: 'unset' }"
          >
            <div class="formItemRT">
              <div
                class="formItemRTL"
                @click="categoryTagAreaShow = true"
              >
                选择分类
              </div>
              <div
                v-if="selCategoryList.length || selTagList.length"
                class="formItemRTR"
              >
                已选：{{ selectCategoryTagLabel }}
                <img
                  src="https://imagessl.lingtuo.cn/A-1ed71af7_20260128141159.png"
                  @click="clearCategoryTag"
                />
              </div>
              <div
                v-else
                class="formItemRTR"
              >
                未分类
              </div>
            </div>
            <div
              v-if="categoryTagAreaShow"
              class="formItemRB"
            >
              <div
                class="formItemRBItemTConfirm"
                @click="confirmCategoryTagSelection"
              >
                确定
              </div>
              <div class="formItemRBItem">
                <div class="formItemRBItemT">
                  <div>选择分类</div>
                </div>
                <div class="formItemRBItemB">
                  <div
                    v-for="category in categoryList"
                    :key="category.labelid"
                    :class="
                      selCategoryList.some(
                        (selCategory) =>
                          selCategory.labelid === category.labelid,
                      )
                        ? 'formItemRBItemBItem formItemRBItemBItemSel'
                        : 'formItemRBItemBItem'
                    "
                    @click="selectCategory(category)"
                  >
                    {{ category.labelName }}
                  </div>
                </div>
                <div
                  v-if="tagList.length"
                  class="formItemRBItemT"
                >
                  选择标签
                </div>
                <div
                  v-if="tagList.length"
                  class="formItemRBItemB"
                  :style="{ 'border-bottom': 'none' }"
                >
                  <div
                    v-for="tag in tagList"
                    :key="tag.tagid"
                    :class="
                      selTagList.some((selTag) => selTag.tagid === tag.tagid)
                        ? 'formItemRBItemBItem formItemRBItemBItemSel'
                        : 'formItemRBItemBItem'
                    "
                    @click="selectTag(tag)"
                  >
                    {{ tag.tagName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="(!sucaiData || (sucaiData && !sucaiData.id) || isTask) && isVip"
          class="formItem"
        >
          <div class="formItemL">定时发布</div>
          <div class="formItemRT">
            <el-date-picker
              v-model="sucaiReleaseTime"
              type="datetime"
              placeholder="选择日期时间"
              @change="changeTaskDateTime"
            >
            </el-date-picker>
          </div>
        </div>

        <!-- 用于继续添加文件的隐藏输入框 -->
        <input
          ref="hiddenFileInput"
          type="file"
          class="hiddenFileInput"
          @change="handleFileSelect"
          :accept="getFileAccept"
          multiple
        />
      </div>
      <div class="editSucaiMainBottomBar">
        <div></div>
        <div
          class="formItemRTL"
          @click="releaseSucai"
        >
          发布
        </div>
      </div>
    </div>
    <!-- 视频预览遮罩层 -->
    <div
      v-if="videoPreviewShow"
      class="videoPreviewMask"
      @click="closeVideoPreview"
    >
      <div
        class="videoPreviewContent"
        @click.stop
      >
        <video
          :src="currentVideoUrl"
          controls
          autoplay
          class="videoPlayer"
        ></video>
        <div
          class="videoCloseBtn"
          @click="closeVideoPreview"
        >
          ×
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import cosService from "@/service/cosService";
import {
  Dialog,
  Button,
  Loading,
  Radio,
  RadioGroup,
  Switch,
  Popover,
  Select,
  Option,
  Input,
  DatePicker,
  Pagination,
} from "element-ui";
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(Pagination);

export default {
  name: "EditSucai",
  data() {
    return {
      pageWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      pageHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      sucaiData: {},
      teamData: {},
      contentTxt: "",
      sucaiType: "1", //1.图片,2.视频,3.链接
      isDragging: false,
      categoryList: [],
      tagList: [],
      allTagList: [],
      selCategoryList: [],
      selTagList: [],
      categoryTagAreaShow: false,
      sucaiReleaseTime: "",
      linkTitle: "",
      linkUrl: "",
      mediaArr: [],
      draggingIndex: null, // 记录当前拖拽项的索引
      isTask: false, // 是否是定时任务
      isNotToday: false,
      showVideoPreview: false,
      videoUrlList: [],
      videoPreviewShow: false,
      currentVideoUrl: "",
    };
  },
  computed: {
    isVip() {
      let isVip =
        localStorage.getItem("edujia:group:web:isVip") == "1" ||
        localStorage.getItem("edujia:group:web:isGroupVip") == "1";
      return isVip;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      };
    },
    // 根据素材类型获取文件接受类型
    getFileAccept() {
      switch (this.sucaiType) {
        case "1": // 图片
        case "3": // 链接
          return "image/*";
        case "2": // 视频
          return "video/*";
        default:
          return "*/*";
      }
    },
    selectCategoryTagLabel() {
      //全部分类不参与拼接
      let categoryLabel = this.selCategoryList
        .map((i) => i.labelName)
        .join("、");
      if (this.selTagList.length) {
        if (categoryLabel) {
          categoryLabel += "-";
        }
        categoryLabel += this.selTagList.map((i) => i.tagName).join("、");
      }
      return categoryLabel;
    },
  },
  watch: {
    sucaiType(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.mediaArr = [];
      }
    },
  },
  components: {},
  methods: {
    handleClose() {},
    previewVideo() {
      this.currentVideoUrl = this.mediaArr.length
        ? this.getObjectURL(this.mediaArr[0].file)
        : this.sucaiData.mediaDomain + this.sucaiData.videoKey;
      this.videoPreviewShow = true;
    },
    closeVideoPreview() {
      this.videoPreviewShow = false;
      this.currentVideoUrl = "";
    },
    imgPreview(index) {
      let _this = this;
      let images = this.mediaArr.map((val) => {
        if (val.waitUpload) {
          val.previewUrl = this.getObjectURL(val.file);
        } else {
          val.previewUrl = val.domain + val.picUrl;
        }
        return val.previewUrl;
      });
      this.$viewerApi({
        images: images,
        options: {
          // 这里可以配置 viewer.js 的原生选项
          toolbar: true,
          navbar: true,
          images: this.sourceImageObjects,
          initialViewIndex: index,
        },
      });
    },
    changeTaskDateTime(val) {
      let newDate = new Date(val);
      if (newDate.getTime() < new Date().getTime()) {
        alert("不能小于当前时间");
        this.sucaiReleaseTime = "";
      }
    },
    //查询分类列表
    queryCategoryList() {
      return new Promise(async (resolve, reject) => {
        let params = {
          teamNo: this.teamData.teamNO,
        };
        let resp = await this.$http.queryCategoryList(params);
        if (resp.code == 200) {
          this.categoryList = [...resp.data.array];
        }
        resolve();
      });
    },
    //查询标签列表
    queryTagList(categoryId) {
      return new Promise(async (resolve, reject) => {
        let params = {
          teamNo: this.teamData.teamNO,
        };
        if (categoryId) {
          params.labelId = categoryId;
        }
        let resp = await this.$http.queryTagList(params);
        if (resp.code == 200) {
          this.tagList = [...resp.data.array];
          if (!categoryId) {
            this.allTagList = resp.data.array;
          }
        }
        resolve();
      });
    },
    async setSucai(sucai) {
      let data = JSON.parse(JSON.stringify(sucai));
      console.log("setSucai:", data);
      this.teamData = data.team;
      this.isTask = data.isTask;
      this.queryCategoryList();
      this.queryTagList();
      if (data.sucai) {
        this.sucaiData = data.sucai;
        this.contentTxt = data.sucai.detail;
        this.sucaiType = data.sucai.mediaType + "";
        this.linkTitle = data.sucai.articleTitle;
        this.linkUrl = data.sucai.articleUrl;
        if (data.sucai.publishTimestamp) {
          this.sucaiReleaseTime = new Date(
            data.sucai.publishTimestamp,
          ).toLocaleString();
        }
        if (data.sucai.labelData) {
          this.selCategoryList = data.sucai.labelData;
        }
        if (data.sucai.tagData) {
          this.selTagList = data.sucai.tagData;
        }
        setTimeout(async () => {

          let imgList = data.sucai.imageUrls;
          if(imgList.length&&imgList.length<=9&&imgList[0].hiddenCount){
            let moreList = await this.getSucaiImgMore(this.sucaiData);
            if(moreList.length){
              imgList=moreList;
              data.sucai.imageUrls = imgList;
            }
          }

          // 为已有图片添加uid以支持key绑定
          this.mediaArr = (imgList || []).map((item, idx) => ({
            ...item,
            uid: Date.now() + idx,
          }));
        }, 1);
      }
    },
    async getSucaiImgMore(sucaiItem){
      return new Promise(async (resolve,reject)=>{
        let resp = await this.$http.querySucaiImageListMore({
          teamNO: this.teamData.teamNO,
          mid: sucaiItem.id
        })
        console.log("querySucaiImageListMore resp:",resp);
        if(resp.code==200){
          resolve(resp.data.array)
        }
      })
    },
    close(needRefresh) {
      this.$emit("close", needRefresh);
    },
    async releaseSucai() {
      let _this = this;
      return new Promise(async (resolve, reject) => {
        let loading = Loading.service({
          lock: true,
          text: "发布中...",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let releaseParams = {
          teamNo: this.teamData.teamNO,
          mediaType: parseInt(this.sucaiType),
        };
        if (this.sucaiReleaseTime) {
          if (
            !localStorage.getItem("edujia:group:web:isVip") &&
            !localStorage.getItem("edujia:group:web:isGroupVip")
          ) {
            loading.close();
            alert("非vip用户不能定时发布");
            return;
          }

          releaseParams.publishTimestamp = new Date(
            this.sucaiReleaseTime,
          ).getTime();
        }
        if (this.sucaiType === "3") {
          releaseParams.articleTitle = this.linkTitle || "";
          releaseParams.articleUrl = this.linkUrl || "";
        }
        if (this.selCategoryList.length && this.selCategoryList[0].labelid) {
          releaseParams.labelData = JSON.stringify(this.selCategoryList);
        } else {
          releaseParams.labelData = "[]";
        }
        if (this.selTagList.length && this.selTagList[0].tagid) {
          releaseParams.tagData = JSON.stringify(this.selTagList);
        } else {
          releaseParams.tagData = "[]";
        }
        if (this.contentTxt) {
          releaseParams.detail = this.contentTxt;
        }
        if (this.sucaiData && this.sucaiData.id) {
          releaseParams.id = this.sucaiData.id;
        }

        console.log("媒体文件上传处理....");
        //媒体文件上传处理
        if (this.sucaiType === "1" || this.sucaiType === "3") {
          let waitUploadImgArr = this.mediaArr.filter(
            (val) => val.type == "img" && val.waitUpload,
          );
          let resultArr = await cosService.uploadFileArr(
            waitUploadImgArr,
            1,
            this.teamData.teamNO,
            1,
          );
          console.log("resultArr:", resultArr);
          //用resultArr更新mediaArr的url
          resultArr.forEach((i) => {
            let mediaItem = this.mediaArr.find((j) => j.seq == i.seq);
            if (mediaItem) {
              mediaItem.url = i.url;
            }
          });
          // 使用当前的 mediaArr 顺序来生成发布参数，确保顺序正确
          releaseParams.imageUrls = JSON.stringify(
            this.mediaArr.map((val, idx) => {
              let picUrl = val.url || val.picUrl;
              return {
                height: val.height,
                width: val.width,
                picUrl: picUrl,
                seq: idx, // 重新分配序号以匹配当前顺序
                size: val.size,
                channel: 10, //1.七牛云 10.腾讯云
                hiddenCount: this.mediaArr.length-9
              };
            }),
          );
        } else if (this.sucaiType === "2") {
          let waitUploadVideoArr = this.mediaArr.filter(
            (val) => val.type == "video" && val.waitUpload,
          );
          let resultArr = await cosService.uploadFileArr(
            waitUploadVideoArr,
            2,
            this.teamData.teamNO,
            1,
          );
          console.log("resultArr:", resultArr);
          resultArr.forEach((i) => {
            let mediaItem = this.mediaArr.find((j) => j.seq == i.seq);
            if (mediaItem) {
              mediaItem.url = i.url;
            }
          });
          releaseParams.videoKey = resultArr[0].key;
          releaseParams.resourceChannel = 10; //1.七牛云 10.腾讯云
        }
        console.log("releaseSucai params:", releaseParams);
        // 防御性校验：确保 imageUrls 中没有缺失 picUrl
        if (
          releaseParams.imageUrls &&
          releaseParams.mediaType !== 2
        ) {
          const imageUrls = JSON.parse(releaseParams.imageUrls);
          const missing = imageUrls.filter((item) => !item.picUrl);
          if (missing.length > 0) {
            console.error("picUrl缺失，阻止发布:", missing);
            loading.close();
            alert("部分图片上传未完成，请重试");
            return;
          }
        }
        let resp;
        if (this.isTask) {
          resp = await this.$http.saveTaskSucai(releaseParams);
        } else {
          resp = await this.$http.saveSucai(releaseParams);
        }
        if (resp.code == 200) {
          console.log("resp:", resp);
          if (this.teamData.roleType == 50) {
            this.$message({
              type: "success",
              message: "提交成功，审核通过后可展示",
            });
          }
        }
        loading.close();
        this.close(true);
        resolve();
      });
    },
    clearCategoryTag() {
      this.selCategoryList = [];
      this.selTagList = [];
      this.tagList = this.allTagList;
    },
    // 确认选择分类
    confirmCategoryTagSelection() {
      this.categoryTagAreaShow = false;
    },
    // 选择分类
    selectCategory(item) {
      if (this.tagList.length) {
        this.selTagList = [];
      }

      if (
        this.selCategoryList.some(
          (selCategory) => selCategory.labelid === item.labelid,
        )
      ) {
        this.selCategoryList = this.selCategoryList.filter(
          (i) => i.labelid !== item.labelid,
        );
        if (!this.selCategoryList.length) {
          this.tagList = this.allTagList;
        }
      } else {
        this.selCategoryList.push(item);
        this.queryTagList(item.labelid);
      }
    },
    // 选择标签
    selectTag(item) {
      if (this.selTagList.some((selTag) => selTag.tagid === item.tagid)) {
        this.selTagList = this.selTagList.filter((i) => i.tagid !== item.tagid);
      } else {
        this.selTagList.push(item);
      }
      if (this.selTagList.length > 1 && this.selCategoryList.length > 1) {
        this.selCategoryList = [];
      }
    },
    // 触发文件选择
    triggerFileInput() {
      console.log("triggerFileInput called");
      console.log("hiddenFileInput exists:", !!this.$refs.hiddenFileInput);
      // 重置文件输入框的值，以便可以重新选择相同的文件
      if (this.$refs.hiddenFileInput) {
        console.log("clicking hiddenFileInput");
        this.$refs.hiddenFileInput.value = "";
        this.$refs.hiddenFileInput.click();
      }
    },

    // 处理文件选择
    async handleFileSelect(event) {
      const files = event.target.files;
      if (files.length) {
        // 将新选择的文件添加到现有的文件列表中
        const newFiles = Array.from(files);
        // 根据素材类型限制文件数量
        if (this.sucaiType === "2" || this.sucaiType === "3") {
          // 视频或链接类型，只能选择一个文件
          let nextSeq = this.getNextSeq();
          let tmpFile = {
            file: newFiles[0],
            waitUpload: true,
            type: this.sucaiType === "2" ? "video" : "img",
            seq: nextSeq,
            size: newFiles[0].size,
            uid: Date.now(), // 添加唯一ID
          };
          if (tmpFile.type == "img") {
            let size = await this.getImageSize(tmpFile.file);
            tmpFile.width = size.width;
            tmpFile.height = size.height;
          }
          this.mediaArr.splice(this.mediaArr.length, 0, tmpFile);
        } else {
          if((this.mediaArr.length+files.length)>30){
            alert("素材数量最多30张")
            return;
          }

          let nextSeq = this.getNextSeq();
          newFiles.forEach(async (item, idx) => {
            let tmpFile = {
              file: item,
              waitUpload: true,
              type: "img",
              seq: nextSeq + idx,
              size: item.size,
              uid: Date.now() + idx, // 添加唯一ID，这对拖拽排序很重要
            };
            if (tmpFile.type == "img") {
              let size = await this.getImageSize(tmpFile.file);
              tmpFile.width = size.width;
              tmpFile.height = size.height;
            }
            this.mediaArr.push(tmpFile);
          });
        }
        console.log("mediaArr:", this.mediaArr);
      }
    },

    // 获取下一个不重复的seq
    getNextSeq() {
      if (this.mediaArr.length === 0) return 0;
      return Math.max(...this.mediaArr.map((m) => m.seq)) + 1;
    },

    //获取图片宽高
    getImageSize(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height,
          });
        };
        img.onerror = (reject) => reject(new Error("图片加载失败"));
      });
    },

    // 处理拖拽进入
    handleDragEnter() {
      this.isDragging = true;
    },

    // 处理拖拽离开
    handleDragLeave() {
      this.isDragging = false;
    },

    // 处理拖拽悬停
    handleDragOver() {
      this.isDragging = true;
    },

    // 处理文件拖放 (外部文件拖入)
    handleFileDrop(event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;
      if (files.length) {
        // 将拖拽的文件添加到现有的文件列表中
        const newFiles = Array.from(files);
        // 根据素材类型限制文件数量
        if (this.sucaiType === "2" || this.sucaiType === "3") {
          // 视频或链接类型，只能选择一个文件
          this.mediaArr.splice(this.mediaArr.length, 0, {
            file: newFiles[0], // 修正：这里应该是 file 不是 url
            waitUpload: true,
            type: this.sucaiType === "2" ? "video" : "img",
            seq: this.getNextSeq(),
            uid: Date.now(),
          });
        } else {
          // 其他类型，支持多个文件
          let nextSeq = this.getNextSeq();
          this.mediaArr.push(
            ...newFiles.map((item, idx) => ({
              file: item, // 修正：这里应该是 file 不是 url
              waitUpload: true,
              type: "img",
              seq: nextSeq + idx,
              uid: Date.now() + idx,
            })),
          );
        }
      }
    },

    // --- 内部图片排序拖拽处理方法 START ---
    handleItemDragStart(index, event) {
      this.draggingIndex = index;
      // 设置拖拽效果
      event.dataTransfer.effectAllowed = "move";
      // 可以在这里设置拖拽时的幻影图片，默认是元素本身
    },

    handleItemDragEnter(index, event) {
      // 可以在这里处理拖入某个位置时的视觉反馈
      if (this.draggingIndex !== null && this.draggingIndex !== index) {
        // 比如：event.target.style.border = '...'
      }
    },

    handleItemDragEnd() {
      this.draggingIndex = null;
    },

    handleItemDrop(index, event) {
      // 防止浏览器默认打开文件的行为
      event.preventDefault();

      // 只有在是内部拖拽时才处理排序
      if (this.draggingIndex !== null && this.draggingIndex !== index) {
        // 移动数组元素
        const itemToMove = this.mediaArr[this.draggingIndex];
        // 先移除
        this.mediaArr.splice(this.draggingIndex, 1);
        // 再插入到新位置
        this.mediaArr.splice(index, 0, itemToMove);
      }

      this.draggingIndex = null;
    },
    // --- 内部图片排序拖拽处理方法 END ---

    // 清空所有已选择的文件
    clearSelectedFiles() {
      this.sucaiData.videoKey = "";
      this.mediaArr = [];
      // 重置文件输入框，以便可以重新选择相同的文件
      setTimeout(() => {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      }, 100);
    },

    // 移除单个文件
    removeFile(index) {
      this.mediaArr.splice(index, 1);
      // 重置文件输入框，以便可以重新选择相同的文件
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    // 检查是否为图片文件
    isImageFile(file) {
      return file && file.type && file.type.startsWith("image/");
    },

    // 检查是否为视频文件
    isVideoFile(file) {
      return file && file.type && file.type.startsWith("video/");
    },

    // 创建文件的本地预览URL
    getObjectURL(file) {
      if (!file) return "";
      return URL.createObjectURL(file);
    },

    // 获取文件扩展名
    getFileExtension(filename) {
      if (!filename) return "";
      const parts = filename.split(".");
      return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : "FILE";
    },

    // 截断过长的文件名
    truncateFileName(filename, maxLength = 12) {
      if (!filename) return "";
      if (filename.length <= maxLength) {
        return filename;
      }
      return filename.substring(0, maxLength) + "...";
    },
  },
  async created() {},
  async mounted() {},
  activated() {},
  watch: {
    // 监听素材类型变化，清空已选择的文件
    sucaiType() {
      this.mediaArr = [];
    },
  },
};
</script>

<style>
.el-radio__label {
  font-size: 16px;
}

.el-radio__input.is-checked .el-radio__inner {
  background-color: #fb5d5c;
  border-color: #fb5d5c;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #fb5d5c;
}

.el-radio__inner {
  width: 16px;
  height: 16px;
}
</style>

<style scoped>
.editSucaiCover {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editSucaiMain {
  width: 880px;
  /* min-height: 790px; */
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  position: relative;
  /* max-height: 90%; */
  /* overflow: scroll; */
}

.editSucaiMainT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 81px;
  padding: 0 24px;
  border-bottom: 1px solid #e5e5e5;
  /* position: absolute;
  left: 0;
  top: 0;
  width: 100%; */
}

.editSucaiMainTL {
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}

.editSucaiMainTR {
  width: 20px;
  height: 20px;
  display: block;
  cursor: pointer;
}

.editSucaiMainB {
  max-height: 582px;
  overflow: scroll;
  padding: 24px;
}
.formItem {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 24px;
}
.formItemL {
  width: 104px;
  height: 40px;
  padding-left: 24px;
  color: #3c3c3c;
  font-size: 18px;
  font-weight: 500;
}
.formItemR {
  width: 400px;
  position: relative;
}
.formItemR textarea {
  width: calc(100% - 24px);
  padding: 12px;
  height: 88px;
  line-height: 24px;
  color: #3c3c3c;
  background-color: #fafafa;
  border-radius: 8px;
  border: none;
  resize: none;
  font-size: 16px;
}

.uploadCover {
  width: 100%;
  min-height: 200px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 2px dashed #e5e5e5;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
}

.uploadCover:hover {
  border-color: #fb5d5c;
  background-color: #fff9f9;
}

.uploadCover.drag-over {
  border-color: #fb5d5c;
  background-color: #fff3f3;
}

.emptyUploadArea {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.emptyFileInput {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.uploadPrompt {
  text-align: center;
  color: #999;
  font-size: 16px;
  z-index: 2;
}

.filesListArea {
  padding: 20px;
  text-align: left;
}

.headerBtns {
  display: flex;
  gap: 8px;
}

.addMoreBtn {
  padding: 4px 12px;
  background-color: #f5f6f6;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #3c3c3c;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.addMoreBtn:hover {
  background-color: #4a90e2;
  color: #fff;
  border-color: #4a90e2;
}

.hiddenFileInput {
  display: none;
}

.clearFilesBtn {
  padding: 4px 12px;
  background-color: #f5f6f6;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #3c3c3c;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clearFilesBtn:hover {
  background-color: #fb5d5c;
  color: #fff;
  border-color: #fb5d5c;
}

.selectedFilesHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #e5e5e5;
}

.clearFilesBtn {
  padding: 4px 12px;
  background-color: #f5f6f6;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #3c3c3c;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clearFilesBtn:hover {
  background-color: #fb5d5c;
  color: #fff;
  border-color: #fb5d5c;
}

.filesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.fileGridItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: grab; /* 增加手型光标 */
  transition: opacity 0.2s, transform 0.2s; /* 增加过渡效果 */
}

/* 拖拽时的样式 */
.fileGridItem:active {
  cursor: grabbing;
}

.fileGridItem.is-dragging {
  opacity: 0.4;
  border-radius: 8px;
  border: 1px dashed #fb5d5c;
}

.filePreview {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  background-color: #f5f6f6;
}

.previewContainer {
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 防止图片本身拦截拖拽事件 */
}

.filePreviewImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.filePreviewVideo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoPlayIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

/* 视频上传区域样式 */
.videoItem {
  width: 720px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  background-color: #f5f6f6;
}

.videoItem.uploadArea {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.videoItem.uploadArea:hover {
  border-color: #fb5d5c;
  background-color: #fff9f9;
}

.videoItem.uploadArea img {
  width: 128px;
  height: 128px;
}

.videoPreview {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
}

.videoPreviewVideo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoRemoveBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 32px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.videoRemoveBtn:hover {
  background-color: #fb5d5c;
}

.videoName {
  padding: 12px;
  font-size: 14px;
  color: #3c3c3c;
  background-color: #fff;
  border-top: 1px solid #e5e5e5;
}

.filePreviewPlaceholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f6f6;
  color: #999;
  font-size: 14px;
}

.fileRemoveBtn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.fileRemoveBtn:hover {
  background-color: #fb5d5c;
}

.fileName {
  margin-top: 8px;
  font-size: 12px;
  color: #3c3c3c;
  text-align: center;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.formItemRT {
  display: flex;
  align-items: center;
}

.formItemRTL {
  font-size: 16px;
  color: #3c3c3c;
  width: 136px;
  height: 40px;
  background-color: #fb5d5c;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.formItemRTR {
  display: flex;
  align-items: center;
  margin-left: 16px;
  font-size: 16px;
}

.formItemRTR img {
  width: 14px;
  height: 14px;
  margin-left: 8px;
}

.formItemRB {
  width: 712px;
  min-height: 336px;
  background-color: #fafafa;
  margin-top: 16px;
  /* overflow: scroll; */
}

/* 1. 滚动条整体（宽高对应横竖滚动条的尺寸） */
.formItemRB::-webkit-scrollbar {
  width: 6px; /* 纵向滚动条宽度 */
  height: 6px; /* 横向滚动条高度 */
}
/* 3. 滚动条滑块（可拖动的部分） */
.formItemRB::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px; /* 圆角优化 */
}
/* 4. 滑块hover/激活状态（提升交互） */
.formItemRB::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.formItemRB::-webkit-scrollbar-thumb:active {
  background: #777;
}

.formItemRBItem {
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 20px;
}

.formItemRBItemT {
  font-size: 16px;
  color: #3c3c3c;
  display: flex;
  justify-content: space-between;
}

.formItemRBItemTConfirm {
  width: 64px;
  height: 32px;
  background-color: #fb5d5c;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  top: 75px;
}

.formItemRBItemB {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e5e5;
}

.formItemRBItemBItem {
  height: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 24px;
  padding: 10px 21px;
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.formItemRBItemBItemSel {
  background: #ffecec;
  border: 1px solid #fb5d5c;
  border-radius: 24px;
  color: #fb5d5c;
}

.editSucaiMainBottomBar {
  width: calc(100% - 92px);
  display: flex;
  justify-content: flex-end;
  padding: 16px 46px;
  border-top: 1px solid #e5e5e5;
  /* position: absolute;
  bottom: 0;
  right: 0; */
}

.videoItem {
  width: 128px;
  height: 128px;
  border-radius: 6px;
}

.hiddenFileInput {
  display: none;
}

.videoPreviewMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoPreviewContent {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  background: #000;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  display: flex;
}

.videoPlayer {
  max-width: 100%;
  max-height: 80vh;
  outline: none;
}

.videoCloseBtn {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.videoCloseBtn:hover {
  background: rgba(255, 255, 255, 0.6);
}
</style>
